export function makeTasks() {
  const t1 = {
    name: 'T1',
    starts_at: '1941-12-07T15:00:00.000Z',
    ends_at: '1941-12-07T17:00:00.000Z',
    load: 5,
    backup_load: 0,
  };
  const t2 = {
    name: 'T2',
    starts_at: '1941-12-07T16:00:00.000Z',
    ends_at: '1941-12-07T18:00:00.000Z',
    load: 4,
    backup_load: 0,
  };
  const t3 = {
    name: 'T3',
    starts_at: '1941-12-07T17:00:00.000Z',
    ends_at: '1941-12-07T20:00:00.000Z',
    load: 3,
    backup_load: 0,
  };
  const t4 = {
    name: 'T4',
    starts_at: '1941-12-07T18:30:00.000Z',
    ends_at: '1941-12-07T20:00:00.000Z',
    load: 2,
    backup_load: 0,
  };
  const t5 = {
    name: 'T5',
    starts_at: '1941-12-07T19:00:00.000Z',
    ends_at: '1941-12-07T21:00:00.000Z',
    load: 3,
    backup_load: 0,
  };
  const t6 = {
    name: 'T6',
    starts_at: '1941-12-07T21:00:00.000Z',
    ends_at: '1941-12-07T23:00:00.000Z',
    load: 3,
    backup_load: 0,
  };
  return [t1, t2, t3, t4, t5, t6];
}

export function makeApplicants() {
  const a1 = {
    user: {
      first_name: 'a',
      last_name: '1',
    },
    status: {
      name: 'Staff',
    },
    time_windows: [{
      starts_at: '1941-12-07T15:00:00.000Z',
      ends_at: '1941-12-07T23:00:00.000Z',
    }],
    task_preferences: [],
  };
  const a2 = {
    user: {
      first_name: 'a',
      last_name: '2',
    },
    status: {
      name: 'Staff',
    },
    time_windows: [{
      starts_at: '1941-12-07T15:00:00.000Z',
      ends_at: '1941-12-07T23:00:00.000Z',
    }],
    task_preferences: [],
  };
  const a3 = {
    user: {
      first_name: 'a',
      last_name: '3',
    },
    status: {
      name: 'Lecturer',
    },
    time_windows: [{
      starts_at: '1941-12-07T15:00:00.000Z',
      ends_at: '1941-12-07T18:00:00.000Z',
    }],
    task_preferences: [],
  };
  const a4 = {
    user: {
      first_name: 'a',
      last_name: '4',
    },
    status: {
      name: 'Undergraduate',
    },
    time_windows: [{
      starts_at: '1941-12-07T14:00:00.000Z',
      ends_at: '1941-12-07T19:00:00.000Z',
    }],
    task_preferences: [],
  };
  const a5 = {
    user: {
      first_name: 'a',
      last_name: '5',
    },
    status: {
      name: 'Undergraduate',
    },
    time_windows: [{
      starts_at: '1941-12-07T16:00:00.000Z',
      ends_at: '1941-12-07T21:00:00.000Z',
    }],
    task_preferences: [],
  };
  const a6 = {
    user: {
      first_name: 'a',
      last_name: '6',
    },
    status: {
      name: 'Lecturer',
    },
    time_windows: [{
      starts_at: '1941-12-07T15:00:00.000Z',
      ends_at: '1941-12-07T20:00:00.000Z',
    }],
    task_preferences: [],
  };
  const a7 = {
    user: {
      first_name: 'a',
      last_name: '7',
    },
    status: {
      name: 'Undergraduate',
    },
    time_windows: [{
      starts_at: '1941-12-07T18:30:00.000Z',
      ends_at: '1941-12-07T21:00:00.000Z',
    }],
    task_preferences: [],
  };
  const a8 = {
    user: {
      first_name: 'a',
      last_name: '8',
    },
    status: {
      name: 'Graduate',
    },
    time_windows: [{
      starts_at: '1941-12-07T17:00:00.000Z',
      ends_at: '1941-12-07T22:00:00.000Z',
    }],
    task_preferences: [],
  };
  const a9 = {
    user: {
      first_name: 'a',
      last_name: '9',
    },
    status: {
      name: 'Graduate',
    },
    time_windows: [{
      starts_at: '1941-12-07T18:00:00.000Z',
      ends_at: '1941-12-07T23:00:00.000Z',
    }],
    task_preferences: [],
  };
  const a10 = {
    user: {
      first_name: 'a',
      last_name: '10',
    },
    status: {
      name: 'Graduate',
    },
    time_windows: [{
      starts_at: '1941-12-07T19:00:00.000Z',
      ends_at: '1941-12-07T23:00:00.000Z',
    }],
    task_preferences: [],
  };
  const a11 = {
    user: {
      first_name: 'a',
      last_name: '11',
    },
    status: {
      name: 'Graduate',
    },
    time_windows: [{
      starts_at: '1941-12-07T21:00:00.000Z',
      ends_at: '1941-12-08T00:00:00.000Z',
    }],
    task_preferences: [],
  };
  const a12 = {
    user: {
      first_name: 'a',
      last_name: '12',
    },
    status: {
      name: 'Lecturer',
    },
    time_windows: [{
      starts_at: '1941-12-07T16:00:00.000Z',
      ends_at: '1941-12-07T21:00:00.000Z',
    }],
    task_preferences: [],
  };
  const a13 = {
    user: {
      first_name: 'a',
      last_name: '13',
    },
    status: {
      name: 'Undergraduate',
    },
    time_windows: [{
      starts_at: '1941-12-07T15:00:00.000Z',
      ends_at: '1941-12-07T17:00:00.000Z',
    }],
    task_preferences: [],
  };
  const a14 = {
    user: {
      first_name: 'a',
      last_name: '14',
    },
    status: {
      name: 'Undergraduate',
    },
    time_windows: [{
      starts_at: '1941-12-07T16:00:00.000Z',
      ends_at: '1941-12-07T18:00:00.000Z',
    }],
    task_preferences: [],
  };
  const a15 = {
    user: {
      first_name: 'a',
      last_name: '15',
    },
    status: {
      name: 'Undergraduate',
    },
    time_windows: [{
      starts_at: '1941-12-07T17:00:00.000Z',
      ends_at: '1941-12-07T20:00:00.000Z',
    }],
    task_preferences: [],
  };
  const a16 = {
    user: {
      first_name: 'a',
      last_name: '16',
    },
    status: {
      name: 'Undergraduate',
    },
    time_windows: [{
      starts_at: '1941-12-07T19:00:00.000Z',
      ends_at: '1941-12-07T21:00:00.000Z',
    }],
    task_preferences: [],
  };
  const a17 = {
    user: {
      first_name: 'a',
      last_name: '17',
    },
    status: {
      name: 'Undergraduate',
    },
    time_windows: [{
      starts_at: '1941-12-07T21:00:00.000Z',
      ends_at: '1941-12-07T23:00:00.000Z',
    }],
    task_preferences: [],
  };

  return [a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12, a13, a14, a15, a16, a17];
}

export function makeTasksTestTWO() {
  const t1 = {
    name: 'T1',
    starts_at: '1941-12-07T15:00:00.000Z',
    ends_at: '1941-12-07T16:00:00.000Z',
    load: 1, // 5
    backup_load: 0,
    variableName: 'V0',
  };
  const t2 = {
    name: 'T2',
    starts_at: '1941-12-07T15:30:00.000Z',
    ends_at: '1941-12-07T18:00:00.000Z',
    load: 1, // 4
    backup_load: 0,
    variableName: 'V1',
  };

  return [t1, t2];
}

export function makeTasksTestB() {
  const t1 = {
    name: 'T1',
    starts_at: '1941-12-07T06:00:00.000Z',
    ends_at: '1941-12-07T08:00:00.000Z',
    load: 1, // 5
    backup_load: 0,
    variableName: 'V0',
  };
  const t2 = {
    name: 'T2',
    starts_at: '1941-12-07T07:00:00.000Z',
    ends_at: '1941-12-07T09:00:00.000Z',
    load: 1, // 4
    backup_load: 0,
    variableName: 'V1',
  };
  const t3 = {
    name: 'T3',
    starts_at: '1941-12-07T09:30:00.000Z',
    ends_at: '1941-12-07T11:00:00.000Z',
    load: 1, // 3
    backup_load: 0,
    variableName: 'V2',
  };
  const t4 = {
    name: 'T4',
    starts_at: '1941-12-07T10:00:00.000Z',
    ends_at: '1941-12-07T12:00:00.000Z',
    load: 1, // 2
    backup_load: 0,
    variableName: 'V3',
  };
  const t5 = {
    name: 'T5',
    starts_at: '1941-12-07T11:30:00.000Z',
    ends_at: '1941-12-07T14:00:00.000Z',
    load: 1, // 2
    backup_load: 0,
    variableName: 'V4',
  };
  // const t6 = {
  //   name: "T6",
  //   starts_at: "1941-12-07T14:30:00.000Z",
  //   ends_at: "1941-12-07T18:00:00.000Z",
  //   load: 1, //2
  //   backup_load: 0,
  // };

  return [t1, t2, t3, t4, t5];
}

export function makeApplicantsTestTWO() {
  const a1 = {
    user: {
      first_name: 'a',
      last_name: '1',
    },
    status: {
      name: 'Staff',
    },
    time_windows: [
      {
        starts_at: '1941-12-07T15:00:00.000Z',
        ends_at: '1941-12-07T18:00:00.000Z',
      },
    ],
    task_preferences: [],
  };
  const a2 = {
    user: {
      first_name: 'a',
      last_name: '2',
    },
    status: {
      name: 'Staff',
    },
    time_windows: [
      {
        starts_at: '1941-12-07T15:00:00.000Z',
        ends_at: '1941-12-07T16:00:00.000Z',
      },
    ],
    task_preferences: [],
  };
  return [a1, a2];
}

export function makeApplicantsTestB() {
  const a1 = {
    user: {
      first_name: 'a',
      last_name: '1',
    },
    status: {
      name: 'Staff',
    },
    time_windows: [
      {
        starts_at: '1941-12-07T06:00:00.000Z',
        ends_at: '1941-12-07T11:00:00.000Z',
      },
    ],
    task_preferences: [],
  };
  const a2 = {
    user: {
      first_name: 'a',
      last_name: '2',
    },
    status: {
      name: 'Staff',
    },
    time_windows: [
      {
        starts_at: '1941-12-07T07:00:00.000Z',
        ends_at: '1941-12-07T09:00:00.000Z',
      },
    ],
    task_preferences: [],
  };
  const a3 = {
    user: {
      first_name: 'a',
      last_name: '3',
    },
    status: {
      name: 'Lecturer',
    },
    time_windows: [
      {
        starts_at: '1941-12-07T08:00:00.000Z',
        ends_at: '1941-12-07T09:30:00.000Z',
      },
    ],
    task_preferences: [],
  };
  const a4 = {
    user: {
      first_name: 'a',
      last_name: '4',
    },
    status: {
      name: 'Undergraduate',
    },
    time_windows: [
      {
        starts_at: '1941-12-07T10:00:00.000Z',
        ends_at: '1941-12-07T12:00:00.000Z',
      },
    ],
    task_preferences: [],
  };
  const a5 = {
    user: {
      first_name: 'a',
      last_name: '5',
    },
    status: {
      name: 'Staff',
    },
    time_windows: [
      {
        starts_at: '1941-12-07T10:30:00.000Z',
        ends_at: '1941-12-07T11:45:00.000Z',
      },
    ],
    task_preferences: [],
  };
  const a6 = {
    user: {
      first_name: 'a',
      last_name: '6',
    },
    status: {
      name: 'Lecturer',
    },
    time_windows: [
      {
        starts_at: '1941-12-07T11:30:00.000Z',
        ends_at: '1941-12-07T14:00:00.000Z',
      },
    ],
    task_preferences: [],
  };
  const a7 = {
    user: {
      first_name: 'a',
      last_name: '7',
    },
    status: {
      name: 'Undergraduate',
    },
    time_windows: [
      {
        starts_at: '1941-12-07T13:00:00.000Z',
        ends_at: '1941-12-07T15:00:00.000Z',
      },
    ],
    task_preferences: [],
  };
  return [a1, a2, a3, a4, a5, a6, a7];
}
